import { useState } from 'react';

import { Colors } from '@/plugins/data/colors';
import { css } from '@/utils';
import { Icon } from '../Icon';
import styles from './styles.module.scss';

type Props = {
  src: string | null;
  alt?: string;
  size?: number;
  className?: string;
};

export function Avatar({ src, alt = 'Profile image', size = 48, className = '' }: Props) {
  const [imgError, setImgError] = useState(false);

  return (
    <div
      className={css(styles.avatar, className)}
      style={{
        width: size,
        height: size
      }}>
      {src && !imgError ? (
        <img
          src={src}
          alt={alt}
          width={size}
          height={size}
          className={styles.img}
          onError={() => setImgError(true)}
          loading='lazy'
        />
      ) : (
        <Icon name='user' size={size * 0.75} color={Colors.secondaryDark} />
      )}
    </div>
  );
}
